import React from 'react';
import styled from 'styled-components';
import { borders, media, spaces } from '../../lib/styles';
import Text from '../Text';

export const TableBody = styled.tbody`
    & + & {
        ::before {
            content: '';
            display: block;
            padding-top: ${spaces.gutter}px;
        }
    }
`;

export const TableRow = styled.tr<{ removeBorder?: boolean }>`
    ${(props) => !props.removeBorder && `border-bottom: ${borders.content};`}
`;

export const TableCell = styled.td<{ align?: string }>`
    text-align: ${(props) => props.align || 'center'};
    padding: ${spaces.space7}px;
    vertical-align: middle;

    @media ${media('normal')}, ${media('large')} {
        padding: ${spaces.space8}px;
    }
`;

const SubHeadingTableCell = styled(TableCell)`
    padding: ${spaces.space6}px 0 !important;

    @media ${media('normal')}, ${media('large')} {
        text-align: left;
    }
`;

const MobileTableRow = styled(TableRow)`
    @media ${media('normal')}, ${media('large')} {
        display: none !important;
    }
`;

export const DesktopTitle = styled(TableCell)`
    text-align: left;
    padding-left: 0;
    display: none;

    @media ${media('normal')}, ${media('large')} {
        display: inherit;
    }
`;

function Title({ children }: { children: React.ReactNode }) {
    return (
        <Text baseClass="paragraph" variations={['no-margin']}>
            {children}
        </Text>
    );
}

interface DataRowProps {
    colSpan: number;
    title: string;
    values: React.ReactNode[];
    className?: string;
}

export function DataRow({ colSpan, title, values, className }: DataRowProps) {
    return (
        <>
            <MobileTableRow removeBorder className={className}>
                <TableCell as="th" colSpan={colSpan} scope="colgroup">
                    <Title>{title}</Title>
                </TableCell>
            </MobileTableRow>
            <TableRow className={className}>
                <DesktopTitle as="th" scope="row">
                    <Title>{title}</Title>
                </DesktopTitle>
                {values.map((value, index) => {
                    return <TableCell key={`title-${index}`}>{value}</TableCell>;
                })}
            </TableRow>
        </>
    );
}

interface SubHeadingProps {
    children: React.ReactNode;
    colSpan: number;
    className?: string;
}

export function SubHeading({ children, colSpan, className }: SubHeadingProps) {
    return (
        <TableRow className={className}>
            <SubHeadingTableCell colSpan={colSpan} as="th" scope="colgroup">
                <Text baseClass="heading" variations={['size4', 'no-margin']}>
                    {children}
                </Text>
            </SubHeadingTableCell>
        </TableRow>
    );
}
